<!-- display-mobile-17 preview — a bordered 300x250 medium rectangle in the
     middle of a publisher page, and the one Display placement that draws no
     creative at all: the advertiser mark sits beside a two-line headline, the
     description runs the full width under both, and the advertiser name and a
     filled pill action follow down to the unit's floor. The page shell and the
     skeleton article text are shared with the other Display mobile placements;
     the browser bar is not, since the mock does not draw one. -->
<app-mobile-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in. With no browser bar above it the
         mock starts the article hard against the screen's top edge, which is
         what .da-bars-top overrides the shared inset for. -->
    <div class="da-bars da-bars-top d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad d-flex flex-column">
      <!-- The AdChoices badge is chrome the network draws over the unit, so it
           is decorative here. It needs no white tile of its own in this
           placement: there is no creative for it to sit on. -->
      <span
        class="da-adchoices d-flex align-items-center justify-content-center"
        aria-hidden="true"
      >
        <i class="bi bi-info-circle"></i>
      </span>

      <div class="da-head d-flex flex-row align-items-start">
        <!-- GenSingleImagePreviewData carries no advertiser field, so the mark
             and the name below are literals, the same compromise the other
             placements make. -->
        <span class="da-brand">
          <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
          <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>
        </span>

        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>
      </div>

      <div class="da-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>

      <div class="da-advertiser">Valamar</div>

      <a
        [href]="data.url" target="_blank" rel="noopener noreferrer"
        class="da-cta d-flex align-items-center justify-content-center"
      >
        <span class="da-cta-label">{{ data.ctaText || "Your call to action" }}</span>
        <i class="bi bi-chevron-right"></i>
      </a>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad; the last rows clip at the frame -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
